
















import { GREEN } from "@/resources/constants/busyReasons";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { i18n } from "@/resources/locales";
import Loader, { CANCELLATION_TIME } from "@/resources/mixins/loader/loader";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
@Component({
  name: "call-retry-error-modal-component",
})
export default class CallRetryErrorModalComponent extends mixins(Loader) {
  showButton = true;
  text = i18n.t("notifications.errorMessages.connectRoomError");
  mounted() {
    if (this.meetingType == MEETING_TYPE.ONE_TO_ONE) {
      this.text = i18n.t("notifications.errorMessages.connectOneToOneError");
    }
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    if (roomId == "0") {
      this.showButton = false;
    }
    const userLocal = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/updateUserStatusAction", {
      userId: userLocal.superSpaceUser.user.id,
      props: {
        availableStatus: GREEN.type,
        availableStatusReason: null,
        emoji: localStorage.getItem("default_emoji"),
      },
      callback: (user) => {
        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
      },
      callbackError: (error) => {},
    });
  }
  get active() {
    return this.$store.getters["SystemStore/getShowCallErrorRetryModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setShowCallErrorRetryModalAction", e);
  }
  get meetingType(): string {
    return this.$store.getters["MeetingStore/getMeetingType"];
  }
  onCancel() {
    this.active = false;
  }
  retryCall() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    if (roomId == "0") {
      return;
    }
    this.startLoader(this.$store, CANCELLATION_TIME.CANCEL_CALL_30);
    this.setLoaderText(this.$store, i18n.t("loader.connectingRoom").toString());
    this.$store?.dispatch("MeetingStore/joinMeetingAction", {
      roomId,
      callback: async (response) => {
        if (!response.data.attendee && !response.data.meeting) return;
        await this.$store?.dispatch(
          "MeetingStore/setMeetingDataAction",
          response.data
        );
        this.$store?.dispatch(
          "MeetingStore/setIsVideoUrlLockedByAdminAction",
          response.data.isVideoUrlLockedByAdmin
        );
        await this.$store?.dispatch("SidebarStore/setOpenCall", true);
        await this.$store?.dispatch(
          "ChatStore/setMinimizeChatAction",
          !this.$store?.getters["UserStore/getConfig"].chat
            .openRoomChatByDefault
        );
        setTimeout(() => {
          this.$store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
        }, 20);
        await this.$store?.dispatch("ChatStore/joinRoomChatAction", { roomId });
        this.stopLoader(this.$store);
      },
      callbackError: (err) => {
        this.stopLoader(this.$store);
      },
    });
    this.onCancel();
  }
}
